import React,{useContext} from 'react'
import DataContext from "../data/DataContext";
import SettingService from '../Services/Setting.service';
import Swal from 'sweetalert2'

function Password() {
  const dataConf = useContext(DataContext)
  const settingService = new SettingService()
  const changePass = (e)=>{
    e.preventDefault()
    const payload = {
      p_a_id: dataConf.a_id,
      p_password: e.target.old_pass.value,
      p_new_password: e.target.new_pass.value,
      p_con_password: e.target.con_pass.value
    }
    // console.log(payload)
    Swal.fire({
      title: 'ยืนยัน',
      text: 'คุณต้องการเปลี่ยนรหัสผ่านหรือไม่',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'ตกลง',
      confirmButtonColor: 'green',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dataConf.blockUI()
        settingService.change(payload).then((result) => {
          dataConf.blockUI()
          if (result.success){
            // console.log(result.data)
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })
          }else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
        });
      }
    })
  }
  return (
    <div className="container pt-3">
        <h4>เปลี่ยนรหัสผ่าน</h4>
        <hr/>
        <div className="card col-sm-4 m-auto p-auto">
          <div className="card-body ">
            <form onSubmit={changePass}>
              <div className="mb-3">
                <input type="password" className="form-control" id="old_pass" placeholder="รหัสผ่าน" />
              </div>
              <div className="mb-3">
                <input type="password" className="form-control" id="new_pass" placeholder="รหัสผ่านใหม่" />
              </div>
              <div className="mb-3">
                <input type="password" className="form-control" id="con_pass" placeholder="ยืนยันรหัสผ่านใหม่" />
              </div>
              <div className="mb-3">
                <button className="btn btn-warning w-100">บันทึก</button>
              </div>
            </form>
          </div>
        </div>
    </div>
  )
}

export default Password